import React from "react";


function MentorshipHeader() {

    return (
        <>
            <div className="pd-header">

                <div className="header-bottom">
                    <h2 className="pd-title has-bg-image">CAMP Mentorship</h2>
                </div>
            </div>
        </>
    );
}

export default MentorshipHeader;
